import React from "react";
import { Option } from "../../libs/types";
import Dropdown from "./Dropdown";

const SelectBoxCell: React.FC<SelectBoxCellProps> = (props: SelectBoxCellProps) => {

  const label = React.useMemo(() => {
    const op =props.options.find(o => String(o.value) === props.value);
    return op ? op.name : "";
  }, [props.value, props.options]);

  return (
    <div>
      {
        props.isConfirmed ? (
          <span>{label}</span>
        ) : (
          <Dropdown
            options={props.options}
            value={props.value}
            onChange={(val) => props.onChange(val)}
          />
        )
      }
    </div>
  )
}

export default SelectBoxCell;

export type SelectBoxCellProps = {
  isConfirmed: boolean;
  options: Option[];
  value: string;
  onChange: (val: any) => void;
}